angular.module('impactx.MenuDirectives').directive('ixDeactivateProductView', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateProductViewCtrl',
        controllerAs: 'deactivateProductViewCtrl',
        templateUrl: 'shared/menu/templates/deactivateproductview.tmpl.html'
    }
});